import { axiosInstance } from '../axios';

const NOTIFICATIONS_URL = '/api/sitenotifications';
class SiteNotificationService {


    async getUserShowedNotifications(){
        return axiosInstance.get(`${NOTIFICATIONS_URL}/user-showed-notifications`);
    }


    async list(params) {

        let queryParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value === null || value === undefined){
                continue;
            }
            queryParams.append(key, value);
        }
        return axiosInstance.get(
            `${NOTIFICATIONS_URL}/list`,
            {
                params: queryParams,
            },
        );
    }

    async get(siteNotificationId) {
        return axiosInstance.get(
            `${NOTIFICATIONS_URL}/get/${siteNotificationId}`);
    }

    async save(siteNotification) {
        return axiosInstance.post(
            `${NOTIFICATIONS_URL}/save`,
            siteNotification,
        );
    }

    async delete(siteNotificationIds) {
        let data = new FormData();
        siteNotificationIds.forEach(id => data.append('ids', id) );
        return axiosInstance.delete(
            `${NOTIFICATIONS_URL}/delete`,
            { data:data },
        );
    }



  async dismiss(siteNotificationId) {
      let queryParams = new URLSearchParams();
      queryParams.append('siteNotificationId', siteNotificationId);
      return axiosInstance.post(
          `${NOTIFICATIONS_URL}/dismiss`,
          { },
          {
              params: queryParams,
          },
      );
  }
}

export default new SiteNotificationService();
